import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  debug(message: string, ...context: unknown[]): void {
    console.log(message, ...context);
  }

  info(message: string, ...context: unknown[]): void {
    console.info(message, ...context);
  }

  warn(message: string, ...context: unknown[]): void {
    console.warn(message, ...context);
  }

  error(message: string, error?: unknown, ...context: unknown[]): void {
    if (error === undefined) {
      console.error(message, ...context);
      return;
    }
    console.error(message, error, ...context);
  }
}
